module.exports = "/assets/data/19faf36bac9dc3af10d9254a9222953c-S70.data.json";